import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse  } from '@angular/common/http';
import { LocalStorageService } from 'ngx-webstorage';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { FunctService } from './funct.service';
import { DtoService } from './dto.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  isLogged: any;
  token: any;
  userProfileBalance : any;
  
  loading: any = {
    apiLoading: {
      name: 'apiLoading',
      size: 'small',
      color: '#ffffff',
      type: 'ball-spin-clockwise',
      fullScreen: true
    },
    refreshLoading: {
      name: 'refreshLoading',
      size: 'medium',
      color: '#32cd32',
      type: 'ball-spin-clockwise',
      fullScreen: true
    },
    balanceLoading: {
      name: 'balanceLoading',
      size: 'small',
      color: '#32cd32',
      type: 'ball-spin-clockwise',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    twodCloseTimeLoading: {
      name: 'twodCloseTimeLoading',
      size: 'small',
      color: '#32cd32',
      type: 'ball-spin-clockwise',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    threedCloseTimeLoading: {
      name: 'threedCloseTimeLoading',
      size: 'small',
      color: '#32cd32',
      type: 'ball-spin-clockwise',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    loginLoading: {
      name: 'loginLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    loginVerifyPhoneLoading: {
      name: 'loginVerifyPhoneLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    authOtpLoading: {
      name: 'authOtpLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    forgetPasswordLoading: {
      name: 'forgetPasswordLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    resetPasswordLoading: {
      name: 'resetPasswordLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    forgetPasswordCheckInfoLoading: {
      name: 'forgetPasswordCheckInfoLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    forgetPasswordCheckInfoSuccessLoading: {
      name: 'forgetPasswordCheckInfoSuccessLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    registerPhoneLoading: {
      name: 'registerPhoneLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    registerInviteCodeLoading1: {
      name: 'registerInviteCodeLoading1',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    registerInviteCodeLoading2: {
      name: 'registerInviteCodeLoading2',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    changePasswordLoading: {
      name: 'changePasswordLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    feedbackLoading: {
      name: 'feedbackLoading',
      size: 'medium',
      color: '#017078',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    inviteCodeLoading: {
      name: 'inviteCodeLoading',
      size: 'medium',
      color: '#017078',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    profileDetailLoading: {
      name: 'profileDetailLoading',
      size: 'medium',
      color: '#ffcb50',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    otpLoading: {
      name: 'otpLoading',
      size: 'medium',
      color: '#017078',
      type: 'ball-elastic-dots',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    },
    twodBetConfirmLoading: {
      name: 'twodBetConfirmLoading',
      size: 'small',
      color: '#017078',
      type: 'ball-spin-clockwise',
      fullScreen: false,
      bdColor: "rgba(0, 0, 0, 0)"
    }
  }
  
  constructor(
    private funct: FunctService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private http: HttpClient,
    private dto: DtoService,
    private storage: LocalStorageService) { 
  
  }
 
  handleError(error: HttpErrorResponse) {
    if (error.status == 423) {
      this.errorMsg("", "youNeedLogin", "top");
      this.storage.store('token', '');
      this.storage.store('isUserLoggedIn', false);
      return;

    } else if (error.status == 400) {
      this.errorMsg("", "bad_request", "top");
      return;

    }
    // return throwError(error);
  }

  getUserProfile() {
    
    this.token = this.storage.retrieve('token');    
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);
      
    this.http.get(this.funct.ipaddress + 'user/PointUserProfile', {headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {
        this.dto.Response = {};
        this.dto.Response = result;
        this.userProfileBalance = this.dto.Response.balance;
        this.storage.store('userMainWallet', this.userProfileBalance);
      }
    );
  }

  async getDateTime() {
    const axios = require('axios').default;
    const response = await axios.get(this.funct.ipaddress + 'value/getDateTime');
    return response.data.utc_datetime;
  }

  async convertMyanmarTime(date: any) {

    const localDate = new Date(date);
    const timeZoneOffset = new Date(date).getTimezoneOffset();
    let offsetMinutes: any;

    if (timeZoneOffset != -390) {
      if (timeZoneOffset < -390) { // thai = -420, china = -480 (early than myanmar)
        offsetMinutes = Math.abs(timeZoneOffset) - 390;

        var hours = (offsetMinutes / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
  
        localDate.setHours(localDate.getHours()-rhours);
        localDate.setMinutes(localDate.getMinutes()-rminutes);
      }
      if (timeZoneOffset > -390) { // us = 420 (later than myanmar)
        offsetMinutes = timeZoneOffset - (-390);

        var hours = (offsetMinutes / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
  
        localDate.setHours(localDate.getHours()+rhours);
        localDate.setMinutes(localDate.getMinutes()+rminutes);
      }
    }

    return localDate;

  }

  warningMsg(tit: string, msg: string, position: string) {

    let title = tit != "" ? this.translateService.instant(tit) : "";
    let message = msg != "" ? this.translateService.instant(msg) : "";

    this.toastr.warning(title, this.translateService.instant(message), {
      timeOut: 2000,
      positionClass: `toast-${position}-center`,
    });
  }
  
  errorMsg(tit: string, msg: string, position: string, translatedMsg?: string, noTranslateMsg?: string) {

    let title = tit != "" ? this.translateService.instant(tit) : "";
    let message = msg != "" ? this.translateService.instant(msg) : translatedMsg != "" ? translatedMsg : noTranslateMsg;

    this.toastr.error(title, message, {
      positionClass: `toast-${position}-center`,
      timeOut: 2000,
      toastClass: 'toast-yellow ngx-toastr'
    });
  }

  successMsg(tit: string, msg: string, position: string) {

    let title = tit != "" ? this.translateService.instant(tit) : "";
    let message = msg != "" ? this.translateService.instant(msg) : "";

    this.toastr.success(title, message, {
      positionClass: `toast-${position}-center`,
      timeOut: 2000
    });
  }
 
}